import { routeConstants } from "@utils/constants";

export const SUBSCRIPTION_LIFECYCLE_STATES = {
  WINBACK_ELIGIBLE: "winbackEligible",
  LEAD: "lead",
  ACTIVE_CUSTOMER: "activeCustomer",
  ACTIVE_SUBSCRIBER: "activeSubscriber",
  AT_RISK_CUSTOMER: "atRiskCustomer",
  AT_RISK_SUBSCRIBER: "atRiskSubscriber",
};

/**
 * Get the subscription lifecycle state and which sources where used to make the determination.
 * @param {*} subscriptionDeterminations
 * @param {*} meristemContext
 * @param {*} url
 */
export const getSubscriptionLifecycleState = (
  subscriptionDeterminations,
  meristemContext,
  url
) => {
  let result = {
    subscriptionLifecycleState: null,
    sources: {
      determinedFromSubscriptions: false,
      determinedFromRouteId: false,
      determinedFromQuerystringParam: false,
    },
  };

  // Get subscriptionLifecycleState using subscriptions (and their determinations).
  result = Object.assign(
    {},
    result,
    getFromSubscriptionDeterminations(
      result.subscriptionLifecycleState,
      result.sources,
      subscriptionDeterminations
    )
  );

  // Get fallback subscriptionLifecycleState using other means of determination.
  result = Object.assign(
    {},
    result,
    getFromOther(
      result.subscriptionLifecycleState,
      result.sources,
      meristemContext,
      url
    )
  );

  return result;
};

/**
 * Get the subscription lifecycle state and sources using user's subscription determinations.
 * @param {*} subscriptionLifecycleState
 * @param {*} sources
 * @param {*} subscriptionDeterminations
 */
const getFromSubscriptionDeterminations = (
  subscriptionLifecycleState,
  sources,
  subscriptionDeterminations
) => {
  const result = {
    subscriptionLifecycleState,
    sources,
  };

  // NOTE(eric): Must check these booleans using strict equality.
  // inTrial 'false' has a different meaning than inTrial 'null'.
  const {
    inTrial,
    inSubscription,
    autoRenewalEnabled,
  } = subscriptionDeterminations;

  if (inTrial === false && inSubscription === false) {
    result.subscriptionLifecycleState =
      SUBSCRIPTION_LIFECYCLE_STATES.WINBACK_ELIGIBLE;
    result.sources.determinedFromSubscriptions = true;
    return result;
  }

  return result;
};

/**
 * Get the subscription lifecycle state and sources from sources other than the user's subscriptions.
 * These should be fallbacks; only valid if the fallback is in agreement with subscriptionLifecycleState
 * or it wasn't determined from subscriptions.
 * @param {*} subscriptionLifecycleState
 * @param {*} sources
 * @param {*} meristemContext
 * @param {*} url
 */
const getFromOther = (
  subscriptionLifecycleState,
  sources,
  meristemContext,
  url
) => {
  const result = {
    subscriptionLifecycleState,
    sources,
  };

  // Winbacks.
  const hasWinbackQuerystringParam = url.search.includes("step=wbk");
  const isWinbackRoute =
    meristemContext.route_id === routeConstants.app14DayFtWeb ||
    meristemContext.route_id === routeConstants.winback ||
    meristemContext.route_id === routeConstants.app14DayReturning ||
    meristemContext.route_id === routeConstants.emailWinback;
  if (
    (subscriptionLifecycleState === null ||
      subscriptionLifecycleState ===
        SUBSCRIPTION_LIFECYCLE_STATES.WINBACK_ELIGIBLE) &&
    (hasWinbackQuerystringParam || isWinbackRoute)
  ) {
    result.subscriptionLifecycleState =
      SUBSCRIPTION_LIFECYCLE_STATES.WINBACK_ELIGIBLE;
    result.sources.determinedFromQuerystringParam = hasWinbackQuerystringParam;
    result.sources.determinedFromRouteId = isWinbackRoute;
    return result;
  }

  return result;
};
